module.exports = __webpack_public_path__ + "static/media/avc_fever.562cee97.svg";